<div class="container-fluid ptCustom">
    <div class="row mt-4 submitMemberNews">
        <div class="col-12">
            <div class="submitMemberNewsWrap mt-4">
                <form [formGroup]="memberNewsForm" class="submitMemberNewsForm">
                    <div class="row gx-5">
                        <div class="col-md-8">

                            <div class="mb-4 col-4" *ngIf="membershipLevel != 'Silver' && membershipLevel != 'Startup'">
                                <label for="articleType" class="form-label">Article Type</label>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <div class="btn-group paymentSelect w-100" role="group"
                                             aria-label="Article Type">
                                            <input [value]="0" [formControl]="articleTypeCtrl"
                                                   type="radio" class="btn-check" name="btnPaymentSelect"
                                                   id="btnPaymentSelect1" autocomplete="off" (change)="checkBPUsed()">
                                            <label class="btn btn-outline-primary" for="btnPaymentSelect1">
                                                News
                                            </label>
                                            <input [value]="1" [formControl]="articleTypeCtrl"
                                                   type="radio" class="btn-check" name="btnPaymentSelect"
                                                   id="btnPaymentSelect2" autocomplete="off" (change)="checkBPUsed()">
                                            <label class="btn btn-outline-primary" for="btnPaymentSelect2">
                                                Best Practice
                                            </label>
                                        </div>
                                        <div *ngIf="articleTypeCtrl.invalid && (articleTypeCtrl.dirty || articleTypeCtrl.touched)">
                                            <i class="fas fa-exclamation-circle"></i> This field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="postingAs" class="form-label">Posting As</label>
                                <input formControlName="postingAs" type="text" class="form-control" id="postingAs" placeholder="Posting As...">
                                <div *ngIf="postingAsCtrl.invalid && (postingAsCtrl.dirty || postingAsCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                            <div class="mb-4" *ngIf="articleType() == 1">
                                <label for="runDate" class="form-label">Date To Run</label>
                                <input formControlName="runDate" type="text" class="form-control"
                                       id="runDate" placeholder="mm/dd/yyyy">
                                <div *ngIf="invalidRunDate">
                                    <i class="fas fa-exclamation-circle"></i> Date is invalid.
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="articleTitle" class="form-label">Article Title</label>
                                <input formControlName="articleTitle" type="text" class="form-control" id="articleTitle" placeholder="Article Title">
                                <div *ngIf="articleTitleCtrl.invalid && (articleTitleCtrl.dirty || articleTitleCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="articleContent" class="form-label">Article Content</label>
                                <!--<textarea formControlName="articleContent" class="form-control" id="articleContent" rows="12"></textarea>-->
                                <editor class="form-control" formControlName="articleContent" licenseKey="gpl" menubar="false"
                                        [init]="{
                                            base_url: '/tinymce',
                                            suffix: '.min',
                                            statusbar: false,
                                            menubar: false,
                                            toolbar: 'undo redo | image link | bold italic | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist',
                                            skin: '../../../assets/css/tinymce',
                                            content_style: 'body { color: #FFFFFF; }',
                                            height: 350,
                                            plugins: 'link lists',
                                            }"></editor>
                                <div *ngIf="articleContentCtrl.invalid && (articleContentCtrl.dirty || articleContentCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4 col-6">
                                <label for="articleType" class="form-label">Image Layout</label>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <div class="btn-group paymentSelect w-100" role="group"
                                             aria-label="Image Layout">
                                            <input [value]="0" [formControl]="imageLayoutCtrl"
                                                   type="radio" class="btn-check" name="btnImageLayoutSelect"
                                                   id="btnLandscapeSelect" autocomplete="off">
                                            <label class="btn btn-outline-primary" for="btnLandscapeSelect">
                                                Landscape
                                            </label>
                                            <input [value]="1" [formControl]="imageLayoutCtrl"
                                                   type="radio" class="btn-check" name="btnImageLayoutSelect"
                                                   id="btnPortraitSelect" autocomplete="off">
                                            <label class="btn btn-outline-primary" for="btnPortraitSelect">
                                                Portrait
                                            </label>
                                        </div>
                                        <div *ngIf="imageLayoutCtrl.invalid && (imageLayoutCtrl.dirty || imageLayoutCtrl.touched)">
                                            <i class="fas fa-exclamation-circle"></i> This field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="articleImg" class="form-label">
                                    Main Image <a href="javascript:void(0);" class="formTooltip" placement="right" ngbTooltip="Allowed file types: png jpg jpeg gif bmp svg webp
                                    Pro tip: Headline text will overlay the image, so avoid distracting graphics or heavy copy.
                                    A horizontal image is recommended."><i class="fa-solid fa-circle-question"></i></a>
                                </label>
                                <input (change)="updateMainImage($event.target)" class="form-control" type="file" id="articleImg">
                            </div>
                            <div class="mb-4">
                                <label for="articleImg" class="form-label">Image Preview</label>
                                <div class="imagePreview adPreview"><img [src]="preview" /></div>
                            </div>
                            <div class="mb-3">
                                <div class="attachmentWrap">
                                    <div class="mb-3">
                                        <label for="articleAtt" class="form-label">
                                            Attachments <a href="javascript:void(0);" class="formTooltip" placement="top" ngbTooltip="Have additional photos or files you'd like to include? Accepted file types: jpg, gif, png, pdf
Max. file size: 512 MB."><i class="fa-solid fa-circle-question"></i></a>
                                        </label>
                                        <input (change)="updateAttachments($event.target)" class="form-control" type="file" id="articleAtt" multiple>
                                    </div>
                                    <div *ngFor="let attachment of attachments; index as ind" class="attachmentBlock mb-3">
                                        <div class="fileType">
                                            <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                                        </div>
                                        <div class="fileInfo">
                                            <span class="fileTitle">
                                                {{attachment.name}}
                                            </span>
                                            <span class="fileSize">
                                                {{attachment.size}}
                                            </span>
                                        </div>
                                        <div class="fileActions">
                                            <!--<a href="javascript:void(0);" class="mb-1"><i class="fa-regular fa-pen-to-square"></i></a-->
                                            <a (click)="removeAttachment(ind)" class="text-danger"><i class="fa-regular fa-times"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-4">
                            <button (click)="submitNews()" type="button" class="btn btn-secondary m-100 newsSubmitBtn">Submit News Article</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>